export const ACC_COUNTRIES = ["UK", "USA", "Australia", "Canada", "Europe", "Malaysia"];

export const ACC_CITIES: Record<string, string[]> = {
    "UK": ["London Zone 1", "London Zone 2", "Manchester Fallowfield", "Birmingham City Centre", "Leeds Headingley", "Glasgow West End", "Edinburgh Old Town", "Bristol Clifton"],
    "USA": ["New York Manhattan", "Boston Fenway", "Chicago Loop", "Los Angeles Westwood", "San Francisco SoMa", "Seattle University District"],
    "Australia": ["Sydney CBD", "Melbourne Carlton", "Brisbane St Lucia", "Perth Nedlands", "Adelaide City"],
    "Canada": ["Toronto Downtown", "Vancouver Kitsilano", "Montreal Plateau", "Ottawa Sandy Hill"],
    "Europe": ["Berlin Mitte", "Paris Latin Quarter", "Madrid Moncloa", "Amsterdam Centrum", "Dublin City Centre"],
    "Malaysia": ["Kuala Lumpur City Centre", "Subang Jaya", "Petaling Jaya"]
};

export const URGENCY_LEVELS = [
    { id: "critical", label: "Critical — within 7 days" },
    { id: "high", label: "High — within 30 days" },
    { id: "moderate", label: "Moderate — 3–6 months" },
    { id: "planning", label: "Planning Ahead" }
];

export const STAY_DURATIONS = [
    { id: "full", label: "Full Academic Year (40–52 weeks)" },
    { id: "semester", label: "One Semester (under 6 months)" },
    { id: "short", label: "Short Course (under 3 months)" }
];

export const ACCOMMODATION_TYPES = [
    { id: "uni-halls", label: "University Halls" },
    { id: "pbsa", label: "Private Student Halls (PBSA)" },
    { id: "hmo", label: "Shared House (HMO)" },
    { id: "studio", label: "Studio / 1‐Bed Flat" },
    { id: "homestay", label: "Homestay" }
];

export const STUDENT_STATUS = [
    { id: "undergrad", label: "Undergraduate" },
    { id: "postgrad", label: "Postgraduate" },
    { id: "professional", label: "Professional / Mature Student" }
];

export const MUST_HAVE_FILTERS = [
    { id: "ensuite", label: "En‐suite / Private Bathroom" },
    { id: "female-only", label: "Female‐Only Household" },
    { id: "bills-included", label: "All Bills Included" },
    { id: "accessible", label: "Accessible / Disabled Access" },
    { id: "pet-friendly", label: "Pet Friendly" }
];

export const GUARANTOR_STATUS = [
    { id: "uk-guarantor", label: "I have a UK guarantor" },
    { id: "service", label: "I will use a guarantor service" },
    { id: "upfront", label: "I will pay 6–12 months upfront" }
];

export const PLATFORMS_BY_COUNTRY: Record<string, string[]> = {
    "UK": ["Rightmove", "Zoopla", "OpenRent", "Gumtree Property", "SpareRoom", "UniHomes", "Student.com", "AmberStudent", "Unite Students", "iQ Student"],
    "USA": ["Zillow Rentals", "Apartments.com", "Realtor.com", "Trulia", "Craigslist", "CollegeRentals", "Student.com", "CampusCribz"],
    "Canada": ["Realtor.ca", "Rentals.ca", "Kijiji Rentals", "Zumper Canada", "PadMapper", "Places4Students", "4stay"],
    "Australia": ["RealEstate.com.au", "Domain.com.au", "Flatmates.com.au", "Rent.com.au", "UniLodge", "Scape", "Student.com"],
    "Europe": ["HousingAnywhere", "Spotahome", "Uniplaces", "Erasmusu", "Idealista", "Immobilienscout24"],
    "Malaysia": ["iProperty Malaysia", "PropertyGuru Malaysia", "Mudah.my", "Speedhome", "HostelHunting", "Student.com"]
};
